export var FicoLabels;

(function (FicoLabels) {
  FicoLabels["Poor"] = "bad";
  FicoLabels["Average"] = "fair";
  FicoLabels["Good"] = "good";
  FicoLabels["Excellent"] = "excellent";
})(FicoLabels || (FicoLabels = {}));

export var getFicoLabelFrom = function getFicoLabelFrom(ficoValue) {
  if (ficoValue === undefined || ficoValue === null) {
    return null;
  }

  if (ficoValue < 630) {
    return FicoLabels.Poor;
  }

  if (ficoValue < 690) {
    return FicoLabels.Average;
  }

  if (ficoValue < 720) {
    return FicoLabels.Good;
  }

  return FicoLabels.Excellent;
};